export const ALLOWED_IMAGE_MIME_TYPES = [
  "image/jpeg",
  "image/jpg",
  "image/heif",
  "image/heic",
  "image/png",
  "image/webp",
  "image/gif",
  "image/svg+xml",
  "image/avif"
];

export const ALLOWED_FILE_MIME_TYPES = [
  "application/pdf",
  "application/msword",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  "text/plain",
  "application/rtf",
  "text/rtf",
  "application/vnd.oasis.opendocument.text"
];

export function getAllowedMimeTypesByFieldType(fieldType) {
  if (fieldType === "image") return ALLOWED_IMAGE_MIME_TYPES;
  if (fieldType === "file") return ALLOWED_FILE_MIME_TYPES;
  return [];
}

function normalizeMimeType(value) {
  return String(value || "")
    .trim()
    .toLowerCase();
}

export function isAllowedMimeType(fieldType, mimeType) {
  const normalizedMimeType = normalizeMimeType(mimeType);
  const allowedTypes = getAllowedMimeTypesByFieldType(fieldType).map(
    normalizeMimeType
  );

  if (!allowedTypes.length || allowedTypes.includes("*/*")) return true;
  if (!normalizedMimeType) return false;

  return allowedTypes.some(allowedType => {
    if (allowedType.endsWith("/*")) {
      const prefix = allowedType.split("/")[0];
      return normalizedMimeType.startsWith(`${prefix}/`);
    }
    return allowedType === normalizedMimeType;
  });
}
